import React, { Component } from 'react';
import classNames from 'classnames';
import FormControl from '../base/FormControl';
import PropTypes from 'prop-types';
import TextField from '../base/TextField';
import DropDown from '../base/DropDown';
import { FieldArray, FormikConsumer } from 'formik';

class RepeatablePhone extends Component {
  constructor(props) {
    super(props);

    this.state = {
      className: ['form-item', 'form-item-phone', 'form-item-phone-repeat'],
      required: props.required,
      rows: [],
      rand: 0
    };

    this.insertRow = this.insertRow.bind(this);
    this.removeRow = this.removeRow.bind(this);
  }

  insertRow = () => {

  };

  removeRow = (i) => {

  };

  renderRow = (row, index, remove) => {
    const name = this.props.name + '.' + index;

    return <div className={classNames(['repeat-row', 'repeat-row-' + row])} key={index}>
      <TextField name={name + '.number'}
        label={index === 0 ? 'Phone' : ''}
        hint="(123 456-7890)"
        className={['form-item-phone-number']} />
      <TextField name={name + '.ext'}
        label={index === 0 ? 'Ext.' : ''}
        className={['form-item-phone-ext']} />
      <DropDown name={name + '.type'}
        className={['form-item-phone-type']}
        label={index === 0 ? 'Phone Type' : ''}
        options={[
          { value: 'Main', label: 'Main' },
          { value: 'TTY/TDD number', label: 'TTY/TDD number' },
          { value: 'Domestic Fax', label: 'Domestic Fax' },
          { value: 'Toll Free', label: 'Toll Free' },
          { value: 'Other phone number', label: 'Other phone number' },
          // { value: 'Foreign number', label: 'Foreign number' },
          // { value: 'Foreign fax', label: 'Foreign fax' },
          // { value: 'Hotline number', label: 'Hotline number' },
        ]} />
      <TextField name={name + '.note'}
        className={['form-item-phone-note']}
        label={index === 0 ? 'Note' : ''} />
      {index > 0 &&
        <button
          className="usa-button usa-button--secondary"
          type="button"
          onClick={() => remove(index)}>
          <span className="glyphicon glyphicon-remove">Delete</span>
        </button>}
    </div>;
  };

  render() {
    return (
      <FormikConsumer>
        {({ errors, touched, values }) => (
          <FormControl label={this.props.label}
            required={this.props.required}
            className={classNames('form-item-repeatable-phone', this.props.className)}
            name={this.props.name}>
            <FieldArray
              name={this.props.name}
              render={arrayHelper => {
                const rows = values[this.props.name] || [];

                return <div>
                  <div className="repeat-rows">
                    {rows.map((row, index) => this.renderRow(row, index, arrayHelper.remove))}
                  </div>
                  <button type="button"
                    className="usa-button usa-button-primary"
                    onClick={() => arrayHelper.push({
                      number: '',
                      ext: '',
                      type: 'Main',
                      note: '',
                    })}
                    disabled={rows.length >= this.props.limit}>
                    {this.props.buttonLabel}
                  </button>
                </div>
              }}>
            </FieldArray>
          </FormControl>
        )}
      </FormikConsumer>
    );
  }
}

RepeatablePhone.defaultProps = {
  limit: 5,
  className: []
};

RepeatablePhone.propTypes = {
  limit: PropTypes.number,
  className: PropTypes.array
};

export default RepeatablePhone;
